export default __webpack_public_path__ + "static/media/system.8681f9e6.png";